import Cookies from 'js-cookie';

/** 默认 cookie 有效期：4 小时（秒） */

export interface CookieSetOptions {
    /**
     * 过期时间：Date 或天数（不传则使用默认 4 小时）
     */
    expires?: number | Date;
    path?: string;
    domain?: string;
    secure?: boolean;
    sameSite?: 'Lax' | 'Strict' | 'None';
}

/**
 * 设置 cookie，默认 expires 与 max-age 为 24 小时
 */

export function setCookie(name: string, value: string, options: CookieSetOptions = {}) {
    const opts = { ...options };
    const now = new Date();
    // 设置过期时间为当前时间 + 24 小时
    now.setHours(now.getHours() + 24);
    if (opts.expires === undefined) {
        opts.expires = now;
    }

    if (import.meta.env.VITE_MODE !== 'development') {
        opts.domain = `.${location.host}`;
    }
    Cookies.set(name, value, opts);
}

/**
 * 获取 cookie
 */
export function getCookie(name: string): string | undefined {
    return Cookies.get(name);
}

/**
 * 删除 cookie
 */
export function removeCookie(name: string, options?: { path?: string; domain?: string }) {
    Cookies.remove(name, options);
}

/**
 * 清空当前域下的所有 cookie
 */
export function clearAllCookies() {
    const all = Cookies.get();
    let domain: string;
    if (import.meta.env.VITE_MODE !== 'development') {
        domain = domain = `.${location.host}`;
    }
    Object.keys(all).forEach(key => {
        Cookies.remove(key, { domain });
    });
}
